import { GenericState } from '@pimm/common';
import { ASYNC_STORE_LIST } from '../consts';
import { StoreListState } from '../state';
import { createGenericSlice } from './genericSlice';

export const StoreListStateDefault = {
  status: 'idle',
  data: [],
};

export const storeListSlice = createGenericSlice<StoreListState>({
  name: ASYNC_STORE_LIST,
  initialState: StoreListStateDefault,
  reducers: {
    clear(state: GenericState<StoreListState>) {
      return StoreListStateDefault;
    },
  },
});

export const storeListReducer = storeListSlice.reducer;
